import React, { Component } from "react";
import {
    Box,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    Divider,
    Typography,
} from "@mui/material";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import GroupsIcon from '@mui/icons-material/Groups';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import EngineeringIcon from '@mui/icons-material/Engineering';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from 'axios'
import TeamList from '../../../components/TeamList/TeamList'
import {APIURL} from '../../../config'
import Onboarding from '../../../components/forms/Onboarding/Onboarding'
import { AnalyticsBrowser } from '@segment/analytics-next'
import { SEGMENTAPIKEY } from '../../../config';

const ACCENT = '#3FA7D6';

const MEMBER_SUBITEMS = [
    { key: 'AllMembers', label: 'All Members', Icon: GroupsIcon },
    { key: 'Managers', label: 'Managers', Icon: SupervisorAccountIcon },
    { key: 'FieldWorkers', label: 'FieldWorkers', Icon: EngineeringIcon },
];

const navItemSx = (selected) => ({
    borderRadius: 1.5,
    mb: 0.5,
    pl: 1.5,
    pr: 1,
    py: 1,
    position: 'relative',
    transition: 'background-color 120ms ease, color 120ms ease',
    color: selected ? ACCENT : 'text.primary',
    backgroundColor: selected ? 'rgba(63, 167, 214, 0.10)' : 'transparent',
    '&:hover': {
        backgroundColor: selected ? 'rgba(63, 167, 214, 0.16)' : 'action.hover',
    },
    '&::before': selected ? {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 6,
        bottom: 6,
        width: 3,
        borderRadius: 2,
        backgroundColor: ACCENT,
    } : undefined,
});

const subNavItemSx = (selected) => ({
    ...navItemSx(selected),
    pl: 4,
    py: 0.75,
});


const analytics = AnalyticsBrowser.load({ writeKey: SEGMENTAPIKEY })

class EmpSideBar extends Component {
    constructor(props){
        super(props)
        this.onDesgChange = this.onDesgChange.bind(this)
        this.onRemove = this.onRemove.bind(this)
    }
    state = {
        key: "0",
        collapse: true,
        employee:[],
        designation:[],
        loggedToSegment: false,
    }
    logToSegment = async () => {
        if(this.state.loggedToSegment) {
          return;
        }
        let page = String(window.location.href).split("/").pop()
        if(page.includes("fieldworker") || page === "" || page === "#") {
            page = "Home";
        } else {
            page = String(page).charAt(0).toUpperCase() + String(page).toLowerCase().slice(1);
        }
        console.log(page,this.props.user.emp_id)
        analytics.page(page, {
            title:page,
            path:page,
        }, {
            userId:String(this.props.user.emp_id),
        })
        console.log("logged to segment successfully")
        this.setState({ loggedToSegment : true });
    }

    async componentDidMount(){
        this.logToSegment();
        let result = await axios.get(APIURL+'/team/', {params: {comp_id: this.props.comp_id}})
        this.setState({employee: result.data.employeeList, designation: result.data.empType})
        const response = await axios.get(APIURL + `/dropdowns/dropdownType/empType?comp_id=${this.props.comp_id}`)
        this.setState({ designation: [...new Set([...this.state.designation, ...response.data]) ]})
        this.onSideBarChange(this.state.key)
    }

    async onDesgChange(empIdArr, desg){
        let res = await axios.put(APIURL+'/team/', {empList: empIdArr, type: desg})
        console.log(res.data)
        if(res.data.code === 200){
            let employee = this.state.employee
            employee.map((emp)=>{
                if(empIdArr.includes(emp.id)){
                    emp.emp_type = desg
                }
                return emp
            })
            console.log(employee)
            await this.setState({employee})
            if(empIdArr.includes(this.props.user.emp_id)){
                window.location.reload()
            }
            
        }else{
            return
        }
    }

    async onRemove(empIdArr){
        let res = await axios.put(APIURL+'/team/remove', {empList: empIdArr})
        // console.log(res.data)
        if(res.data.code === 200){
            let employee = this.state.employee
            empIdArr.forEach(id => {
                employee = employee.filter((emp) => (emp.id !== id))  
            });
            // console.log(employee)
            this.setState({employee})
        }else{
            return
        }
    }

    onSideBarChange = (key) => {
        if ((key !== "AllMembers" || key !== "Managers" || key !== "FieldWorkers") && this.state.collapse) {
            // this.toggle.click()
            // this.setState
            // (toggleEvent) => this.toggle = toggleEvent
            // this.toggle()
            this.setState({ key, collapse: false })
        }

        if (key === "AllMembers" || key === "Managers" || key === "FieldWorkers" || key==='0') {
            this.setState({ key, collapse: true })
            return
        }

        this.setState({key})
    }

    onToggle = () => {
        const oldState = { ...this.state }
        oldState.collapse = !this.state.collapse
        if (oldState.collapse) {
            oldState.key = this.state.key
        }
        this.setState(oldState)
    }


    render() {
        return (
            <div>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' } }}>
                    <Grid container sx={{width: '100%'}} spacing={2}>
                        <Grid className={"debug1"} size={{ xs:12, sm:6, md:4, lg:3 }} sx={{ maxWidth: '15rem' }}>
                            <Box
                                sx={{
                                    position: { md: 'sticky' },
                                    top: { md: 16 },
                                    p: 1.5,
                                    bgcolor: 'background.paper',
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                                }}
                            >
                                <Typography
                                    variant="overline"
                                    sx={{
                                        px: 1.5,
                                        color: 'text.secondary',
                                        fontWeight: 600,
                                        letterSpacing: 0.6,
                                    }}
                                >
                                    Team
                                </Typography>
                                <List component="nav" sx={{ pt: 1 }}>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            onClick={() => { this.onToggle(); this.onSideBarChange("0"); }}
                                            sx={navItemSx(this.state.key === '0')}
                                        >
                                            <ListItemIcon sx={{ minWidth: 36, color: 'inherit' }}>
                                                <PeopleAltIcon />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary="Members"
                                                primaryTypographyProps={{ fontWeight: 600 }}
                                            />
                                            {this.state.collapse ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                                        </ListItemButton>
                                    </ListItem>

                                    <Collapse in={this.state.collapse} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding sx={{ mt: 0.5 }}>
                                            {MEMBER_SUBITEMS.map(({ key, label, Icon }) => (
                                                <ListItem key={key} disablePadding>
                                                    <ListItemButton
                                                        onClick={() => this.onSideBarChange(key)}
                                                        sx={subNavItemSx(this.state.key === key)}
                                                    >
                                                        <ListItemIcon sx={{ minWidth: 32, color: 'inherit' }}>
                                                            <Icon fontSize="small" />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={label}
                                                            primaryTypographyProps={{ fontSize: 14 }}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Collapse>

                                    {this.props.user.permissions.InviteEmployees && (
                                        <>
                                            <Divider sx={{ my: 1 }} />
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    onClick={() => this.onSideBarChange('Invites')}
                                                    sx={navItemSx(this.state.key === 'Invites')}
                                                >
                                                    <ListItemIcon sx={{ minWidth: 36, color: 'inherit' }}>
                                                        <MeetingRoomIcon />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary="Invites"
                                                        primaryTypographyProps={{ fontWeight: 600 }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        </>
                                    )}
                                </List>
                            </Box>
                        </Grid>
                        <Grid size={{ xs:12, sm:8, md:8, lg:8 }}>
                            {(this.state.key === "AllMembers" || this.state.key === "0") && (
                                <TeamList user={this.props.user} desgList={this.state.designation} onRemove={this.onRemove} onDesgChange={this.onDesgChange} contextName={'All Members'} employeeList={this.state.employee}/>
                            )}
                            {this.state.key === "Managers" && (
                                <TeamList user={this.props.user} desgList={this.state.designation} onRemove={this.onRemove} onDesgChange={this.onDesgChange} contextName={'Managers'} employeeList={this.state.employee.filter((emp)=>(emp.emp_type === 'Manager'))}/> 
                            )}
                            {this.state.key === "FieldWorkers" && (
                                <TeamList user={this.props.user} desgList={this.state.designation} onRemove={this.onRemove} onDesgChange={this.onDesgChange} contextName={'FieldWorkers'} employeeList={this.state.employee.filter((emp)=>(emp.emp_type === 'Fieldworker'))}/>
                            )}
                            {this.state.key === "Invites" && (
                                <Onboarding user={this.props.user}/>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </div>
        )
    }
}

export default EmpSideBar;